export const MAX_NOTIFICATION_VISIBLE = 5
export const OFFSET_COUNT_LOAD_PROFILE_HISTORY = 10
export const MAX_SEARCH_PARAMS_VISIBLE_IN_DASHBOARD = 3
export const MAX_PAGINATION_PAGE = 200
export const COUNT_GROUPS_PER_LOAD = 7
export const COUNT_ITEMS_LOAD_PER_PAGE = 40
export const THRESHOLD_VISIBLE_SEARCH_ITEMS = 4
export const COUNT_CREATIVES_LOAD_PER_PAGE = 40
